import { useGetDormakabaConnection } from '@/api/property-keyless/dormakaba/get-dormakaba-connection'

import { dormakabaDefaultValues } from './dormakaba.schema'

// Note: GET response shape is unverified (no schema available at implementation time) — used
// purely as a connected/not-connected probe, same as legacy Swiftlane. Fields are never
// pre-filled from the response; the form always starts blank.
export const useDormakabaConnection = (buildingId: number) => {
  const { isSuccess, isLoading } = useGetDormakabaConnection({ buildingId })

  return { isConfigured: isSuccess, isLoading, values: dormakabaDefaultValues }
}
